import { JsonObject, JsonProperty } from 'json2typescript';

@JsonObject('ShopStatisticPackage')
export class ShopStatisticPackage {

  @JsonProperty('package_id', String)
  packageId: string = '';

  @JsonProperty('price_amount_total', Number)
  priceAmountTotal: number = 0;

  @JsonProperty('count', Number)
  count: number = 0;
}
